import { useMutation } from '@tanstack/react-query';
import { setupParkingLots } from '../../api/parking-contract.ts';
import type { SetupParkingLotsRequest } from '../../api/requests/parking-contract-request.ts';
import type { ErrorResponse } from '../../api/responses/error-response.ts';

export default function useSetupParkingLots() {
  return useMutation<string, ErrorResponse, SetupParkingLotsRequest>({
    mutationFn: (request: SetupParkingLotsRequest) => setupParkingLots(request),
  });
}
